import React from "react";
import { useParams } from "react-router";
import { Callout } from "@/components/common/Callout";
import { useOrgContextStore } from "@/components/main/stores/orgContextStore";
import { useAppPage, useApps } from "@/lib/api/apps/hooks";
import { DesignPage } from "./design/design-page";
import { AppPageHead, AppPageShell } from "./page-shell";
import { ResearchAppPage } from "./research/research-page";

/** `/apps/:app_id`: the page of the app's own kind, opened at once when the
 *  list already says which kind it is. */
export const AppRoute: React.FC = () => {
  const { app_id } = useParams();
  const orgId = useOrgContextStore((s) => s.activeOrgId);
  const page = useAppPage(app_id ?? null);
  const listed = useApps(orgId).data?.find((a) => a.app_id === app_id);
  const kind = page.data?.kind ?? listed?.kind;
  if (kind === "design" && app_id)
    return <DesignPage appId={app_id} name={listed?.name} />;
  if (kind === "research") return <ResearchAppPage />;
  if (page.isLoading) {
    return (
      <AppPageShell maxWidth="72rem">
        <AppPageHead
          trail={[{ label: "Applications", to: "/apps" }]}
          title=""
        />
      </AppPageShell>
    );
  }
  return (
    <div className="flex h-full w-full items-center justify-center px-6">
      <Callout variant="error" title="This app could not be opened">
        {(page.error as Error | null)?.message ??
          "it is not a design or research app"}
      </Callout>
    </div>
  );
};
